const blackCSS = require('../../insa-css/black.css');
let customBlackCSS = undefined;

if (process.env.INSA_CLIENT && process.env.INSA_CLIENT !== '') {
  customBlackCSS = require('../../insa-css/insa-clients/' + process.env.INSA_CLIENT + '/css/black.css');
}

const style_cookie_name = "style" ;
const style_cookie_duration = 30 ;
const style_domain = window.location.hostname;
// console.log('Cookie domain: ' + style_domain);
let currentStyle = 'default';
let blackStyleBackup = undefined;
let blackScriptBackup = undefined;


// WEBPACK version of switching styles:
// loader: 'style-loader/useable' is used to turn off/on usage of black style
// SUPPORTED PARAMETERS: name = 'default' or 'black'
function switch_style(name) {
  if (currentStyle === name) {
    // console.log('Same style as current selected.');
    // return early as logic doesn't support the same style selected 2 times
    return;
  }
  let prevStyle = currentStyle;
  currentStyle = name;
  localStorage.setItem("color", currentStyle);
  // unload previous style
  switch(prevStyle) {
    case 'default':
      // nothing needed
    case 'black':
      blackCSS.unuse();
      if (customBlackCSS) {
        customBlackCSS.unuse();
      }
      break;
  }
  // load the new style
  switch(name) {
    case 'default': //
      // nothing needed to be loaded, all basic
      break;
    case 'black':
      blackCSS.use();
      if (customBlackCSS) {
        customBlackCSS.use();
      }
      break;
    default:
      throw new Error('Unknown theme "' + name + '"');
  }
}

window['switch_style'] = switch_style;

function setDesktopTheme (theme) {
  localStorage.setItem('desktopTheme', theme);
}

window['setDesktopTheme'] = switch_style;

function set_style_from_cookie()
{
  var css_title = get_cookie( style_cookie_name );
  console.log('set_style_from_cookie: ' + css_title);  
  if (css_title.length) {
    switch_style( css_title );
  } else {
    switch_style('default');
  }
}

function set_cookie ( cookie_value, cookie_name = style_cookie_name, 
    lifespan_in_days = style_cookie_duration, valid_domain = style_domain)
{
    // var domain_string = valid_domain ?
    //                    ("; domain=" + valid_domain) : '' ;
    // document.cookie = cookie_name +
    //                    "=" + encodeURIComponent( cookie_value ) +
    //                    "; max-age=" + 60 * 60 *
    //                    24 * lifespan_in_days +
    //                    "; path=/" + domain_string ;
    localStorage[cookie_name] = cookie_value;
}
function get_cookie ( cookie_name )
{
    // var cookie_string = document.cookie ;
    // if (cookie_string.length != 0) {
    //     var cookie_value = cookie_string.match (
    //                     '(^|;)[\s]*' +
    //                     cookie_name +
    //                     '=([^;]*)' );
    //     return decodeURIComponent ( cookie_value[2] ) ;
    // }
    // return '' ;
    return localStorage[cookie_name] || '';
}



//window['set_style_from_cookie'] = set_style_from_cookie;


// WEBPACK FOOTER //
// ./app/insa-custom-scripts/layout.ts